import Rox from "rox-browser";

export const featureFlags = {
  addExternalPolicy: new Rox.Flag(false),
  uploadProofOfCoverageToResident: new Rox.Flag(false),
  searchResidents: new Rox.Flag(false),
  banners: new Rox.Flag(false),
  addPortfolioViaIntegration: new Rox.Flag(false),
};

const applyLocalOverrides = (appName: string, baseUrl: string) => {
  const localFlags = Object.keys(featureFlags);
  const overrides = Rox.overrides as
    | { setOverride?: (name: string, value: string) => void }
    | undefined;

  if (!overrides?.setOverride) return;

  fetch(`${baseUrl}/flags`)
    .then((res) => (res.ok ? res.json() : null))
    .then((flags: Record<string, unknown> | null) => {
      if (!flags) return;
      for (const name of localFlags) {
        if (Object.prototype.hasOwnProperty.call(flags, name)) {
          overrides.setOverride!(`${appName}.${name}`, String(flags[name]));
        }
      }
    })
    .catch(() => {
      // Local feature-flags stub unreachable — keep SDK defaults.
    });
};

export const initializeFeatureFlags = async (appName: string) => {
  Rox.register(appName, featureFlags);

  const roxKey = process.env.VITE_ROX_KEY;

  if (!roxKey) {
    applyLocalOverrides(
      appName,
      process.env.VITE_FEATURE_FLAGS_BASE_URL || "http://localhost:8091"
    );
    return;
  }

  try {
    await Rox.setup(roxKey);
  } catch {
    applyLocalOverrides(
      appName,
      process.env.VITE_FEATURE_FLAGS_BASE_URL || "http://localhost:8091"
    );
  }
};
